import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiEdit3, FiBarChart3, FiTarget, FiHome } = FiIcons;

const Header = ({ currentView, setCurrentView }) => {
  const navItems = [
    { id: 'dashboard', label: 'Dashboard', icon: FiHome },
    { id: 'daily', label: 'Daily Log', icon: FiEdit3 },
    { id: 'project', label: 'Projects', icon: FiTarget }
  ];

  return (
    <header className="bg-white/80 backdrop-blur-md rounded-2xl shadow-lg border border-white/20 p-6">
      <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
        <motion.div 
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          className="flex items-center gap-3"
        >
          <div className="w-10 h-10 bg-gradient-to-br from-blue-600 to-indigo-700 rounded-xl flex items-center justify-center">
            <SafeIcon icon={FiEdit3} className="text-white text-lg" />
          </div>
          <div>
            <h1 style={{
      fontSize: '28px'
    }} className="text-2xl font-bold bg-gradient-to-r from-blue-700 to-indigo-800 bg-clip-text text-transparent">GospelWise Author</h1>
            <p style={{
      fontSize: '16px'
    }} className="text-sm text-slate-600">Book Project Tracker</p>
          </div>
        </motion.div>

        <nav className="flex bg-slate-100 rounded-xl p-1">
          {navItems.map((item, index) => (
            <motion.button
              key={item.id}
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
              onClick={() => setCurrentView(item.id)}
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 flex items-center gap-2 ${
                currentView === item.id
                  ? 'bg-white text-blue-700 shadow-md'
                  : 'text-slate-600 hover:text-blue-700 hover:bg-white/50'
              }`}
            >
              <SafeIcon icon={item.icon} className="text-sm" />
              <span className="hidden sm:inline">{item.label}</span>
            </motion.button>
          ))}
        </nav>
      </div>
    </header>
  );
};

export default Header;